<template>
  <nav
    :class="['navbar', $style.navbar]"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <div class="navbar-item">
        <!-- router-link only works for internal links -->
        <a :href="jaasDashboardUrl">
          <img
            src="@/assets/images/jbi_navbar_img@2x.png"
            width="68.57"
            height="30"
          />
        </a>
      </div>
      <div class="navbar-item">
        <router-link :class="$style.divider" to="/">
          <img
            src="@/assets/images/logo_paces@2x.png"
            width="128.26"
            height="30"
          />
        </router-link>
      </div>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span> <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu">
      <div
        class="navbar-start"
        :class="$style.navbarItemContainer"
        v-if="isLoggedIn"
      >
        <router-link
          v-if="showWithoutSubscriptionLink"
          :class="[
            'navbar-item',
            $style.navItem,
            isNavActive('dashboard') ? 'exact-active' : '',
          ]"
          to="/dashboard"
        >
          DASHBOARD
        </router-link>

        <router-link
          :class="[
            'navbar-item',
            $style.navItem,
            isNavActive('project') ? 'exact-active' : '',
          ]"
          to="/projects/me"
        >
          PROJECTS
        </router-link>

        <router-link
          v-if="showWithoutSubscriptionLink"
          :class="[
            'navbar-item',
            $style.navItem,
            isNavActive('site') ? 'exact-active' : '',
          ]"
          to="/site"
        >
          Sites
        </router-link>
      </div>
      <div class="navbar-end">
        <div :class="['navbar-item', $style.navEndItem]">
          <SurveyAcknowledgement
            v-if="showSurveyButton"
            :showSurveyModal="showSurveyModal"
          />
          <!-- TODO: Disable Notifications -->
          <!-- <BaseNotificationDropdown
            v-if="isLoggedIn && showWithoutSubscriptionLink"
            :notificationInfo="notificationInfo"
            :notificationCount="notificationCount"
            :notificationIds="notificationIds"
            @updateNotification="rerenderNotificationDropdown()"
            :key="notificationKey"
          /> -->
          <div :style="'width: 100px;display: flex;justify-content: flex-end;'">
            <slot name="main"></slot>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { RootState } from '../../store/store';
import { useUserEmail } from '../../utils/user.util';
import { get as _get, cloneDeep as _cloneDeep } from 'lodash';
import { isTruthy } from '../../jbi-shared/util/watcher.vue-decorator';
import BaseNotificationDropdown from './BaseNotificationDropdown.vue';
import { GetNotificationsPayload } from '../../store/modules/notification/types/notification.types';
import SurveyAcknowledgement from '../SurveyAcknowledgement.vue';
import { SurveyDTO } from '../../store/modules/users/types/users.types';
import { ApiState } from '../../store/types/general.types';

@Component({
  components: {
    BaseNotificationDropdown,
    SurveyAcknowledgement,
  },
})
export default class Navbar extends Vue {
  @Prop({ default: 'default' })
  public layout!: string;
  @Prop({
    default() {
      return false;
    },
  })
  public isAdmin!: boolean;

  @Prop({
    default() {
      return false;
    },
  })
  public isLoggedIn!: boolean;

  @Prop({
    default() {
      return true;
    },
  })
  public showWithoutSubscriptionLink!: boolean;

  @Action('notifications/getNotificationDropdown')
  public getNotificationDropdown!: () => void;

  @Action('notifications/getUserNotification')
  public getUserNotification!: (params: GetNotificationsPayload) => void;

  @State((state: RootState) => state.notifications.notificationDropdown)
  public notificationDropdown!: any;

  @State((state: RootState) => state.users.surveyData)
  public surveyData!: SurveyDTO;

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  public notificationCount: number = 0;
  public notificationInfo: any = [];
  public notificationIds: number[] = [];
  public notificationKey: number = Math.floor(Math.random() * 999);
  public showSurveyButton: boolean =
    this.surveyData && this.surveyData.isSurveyActive ? true : false;
  public showSurveyModal: boolean = false;
  public jaasDashboardUrl = process.env.VUE_APP_JAAS_DASHBOARD_URL;

  public rerenderNotificationDropdown() {
    if (this.$route.path !== '/notification') {
      this.getNotificationDropdown();
    }
  }

  public mounted(): void {
    this.showSurveyButton = this.surveyData && this.surveyData.isSurveyActive;
    this.showSurveyModal = false;
  }

  // TODO: Disable Notification
  // public async mounted() {
  //   if (this.isLoggedIn) {
  //     if (this.layout === 'default') {
  //       this.getNotificationDropdown();
  //     }
  //   }

  //   if (
  //     this.isLoggedIn &&
  //     this.showWithoutSubscriptionLink &&
  //     this.layout === 'default'
  //   ) {
  //     this.$socket.client.open();
  //     this.$socket.client.on('connect', () => {
  //       // this.$socket.client is `socket.io-client` instance
  //       // authApi.updateSessionSocket(this.$socket.client.id);
  //       this.$socket.client.emit('JOIN_NOTIFICATION', {
  //         userId: this.userEmail,
  //       });
  //       this.$socket.$subscribe('NOTIFICATION', async (payload: any) => {
  //         if (payload.type === 'VIEWED_NOTIFICATION') {
  //           this.notificationCount = 0;
  //           this.notificationInfo = [];
  //           this.notificationKey += 1;
  //         } else if (payload.type === 'VIEWED_SINGLE_NOTIFICATION') {
  //           this.notificationCount =
  //             this.notificationCount === 0 ? 0 : this.notificationCount - 1;
  //           const viewedNotification = this.notificationInfo;
  //           viewedNotification.filter((data: any, index: number) => {
  //             if (data.id === payload.notificationId) {
  //               this.notificationInfo.splice(index, 1);
  //             }
  //           });
  //           this.notificationKey += 1;
  //         } else {
  //           this.getNotificationDropdown();
  //         }
  //       });
  //     });
  //   }
  // }

  public beforeDestroy() {
    // TODO: Disable Notification
    // if (this.$socket.connected) {
    //   this.$socket.client.off('LEAVE_NOTIFICATION');
    // }
  }

  @Watch('notificationDropdown')
  @isTruthy
  public watchUserNotification(newValue: any) {
    this.notificationInfo = [];
    if (newValue && newValue.notificationInfoDetail.length > 0) {
      this.notificationInfo = _cloneDeep(newValue.notificationInfoDetail);
      this.notificationCount = newValue.totalItemsCount;
      this.notificationIds = newValue.notificationIds;
      this.notificationKey += 1;
    }
  }

  @Watch('surveyData', { deep: true })
  public onSurveyDataChange(): void {
    this.showSurveyButton = this.surveyData && this.surveyData.isSurveyActive;
    this.showSurveyModal = this.surveyData && !this.surveyData.isSurveyTaken;
  }

  private isNavActive(navItemName: string) {
    return this.$route.path.indexOf(navItemName) >= 0;
  }
}
</script>

<style lang="scss" module>
.navbar {
  padding: 0 40px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  &#{&} {
    min-height: 60px;
  }
}

.navbarItemContainer {
  &#{&} {
    flex-grow: 1;
    justify-content: center;

    a:hover {
      color: $secondary;
    }
  }

  .navItem {
    margin: 17px 2rem;
    border-bottom: 2px solid transparent;
    color: #9a9a9a;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    text-transform: uppercase;
    padding: 0;

    &:focus,
    &:hover {
      background-color: transparent;
      border-bottom: 2px solid $secondary;
    }

    &:global(.exact-active) {
      color: $secondary;
      border-bottom: 2px solid $secondary;
    }
  }
}

.loadingBar {
  &#{&} {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100vw;
    min-height: 10px;
  }
}

.navEndItem {
  padding-right: 0px !important;
  text-align: end;
}

.divider {
  border-left: 1px solid $grey-border-3;
  padding-left: 20px;
}
</style>
